import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConceptContactModel } from './conceptcontact.model';
import { ConceptModel } from '../concept/concept.model';
import { ConceptContactService } from './conceptcontact.service';
import { ConceptService } from '../concept/concept.service';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../shared/dummy.component';
import { ContactService } from '../../contact/contact/contact.service';
import { ContactModel } from '../../contact/contact/contact.model';

@Component({
    selector: 'convfact-conceptcontact',
    templateUrl: './conceptcontact.component.html',
    styleUrls: ['./conceptcontact.component.css'],
    standalone: false
})
export class ConceptContactComponent implements OnInit {
  conceptContact = new ConceptContactModel();
  errors = {};
  concepts: ConceptModel[] = [];
  contacts: ContactModel[] = [];

  submit(): void {}

  constructor(
    private conceptContactService: ConceptContactService,
    private conceptService: ConceptService,
    private contactService: ContactService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent
  ) {}

  saveData = (conceptContact): void => {
    if (conceptContact.uid == null) {
      this.conceptContactService.addData(conceptContact)
        .then(result => {
          this.conceptContact = result;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => this.displayInfo(errors.error['message']));
    } else {
      this.conceptContactService.editData(conceptContact.uid, conceptContact)
        .then(result => {
          this.conceptContact = result;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => {
          this.displayInfo(errors.error['message']);
        });
    }
  };

  ngOnInit(): void {
    this.contactService.getListClients().then(contacts => {
      this.contacts = contacts;
      this.conceptService.getList().then(concepts => {
        this.concepts = concepts;
        this.route.params.subscribe(params => {
          const uid = params['uid'];
          if (uid != undefined && uid.length === 36) {
            this.conceptContactService.loadData(uid).then(conceptContact => this.conceptContact = conceptContact);
          }
        });
      });
    });
  }

  returnToIndex = (): void => {
    this.router.navigate(['/conceptcontact/edit']);
  };

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }
}